import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { insightsHeader, Octopus } from '@maximizer/core/shared/domain';
import { map, Observable } from 'rxjs';
import { ContextService } from './context.service';

@Injectable()
export class AppointmentService {
  constructor(
    private readonly http: HttpClient,
    private readonly context: ContextService,
  ) {}

  readList(
    query:
      | Octopus.SearchQuery<Octopus.Appointment>
      | Octopus.LogicalQuery<Octopus.Appointment>,
  ): Observable<Octopus.Appointment[]> {
    const request: Octopus.AppointmentReadRequest = {
      Appointment: {
        Scope: {
          Fields: {
            Key: 1,
            Subject: 1,
            StartDate: 1,
            EndDate: 1,
          },
        },
        Criteria: {
          SearchQuery: query,
        },
      },
      Globalization: Octopus.DefaultGlobalization,
    };

    return this.http
      .post<Octopus.AppointmentResponse>(
        `${this.context.api}${Octopus.Action.READ}`,
        request,
        { headers: this.getRequestHeaders() },
      )
      .pipe(
        map((result) => {
          if (
            result?.Code === Octopus.ResponseStatusCode.Successful &&
            result.Appointment?.Data
          ) {
            return result.Appointment.Data;
          }
          return [];
        }),
      );
  }

  delete(appointmnetKeys: string[]): Observable<boolean> {
    const request: { [name: string]: unknown } = {};

    if (appointmnetKeys) {
      appointmnetKeys.forEach(
        (key, index) =>
          (request['Appointment.' + index] = { Data: { Key: key } }),
      );
    }

    return this.http
      .post<Octopus.Response>(
        `${this.context.api}${Octopus.Action.DELETE}`,
        request,
        { headers: this.getRequestHeaders() },
      )
      .pipe(
        map((result) => {
          return result.Code === Octopus.ResponseStatusCode.Successful;
        }),
      );
  }

  create(appointment: Octopus.AppointmentCreate): Observable<string | null> {
    const request: Octopus.AppointmentCreateRequest = {
      Appointment: {
        Data: appointment,
      },
    };
    return this.http
      .post<Octopus.AppointmentCreateResponse>(
        `${this.context.api}${Octopus.Action.CREATE}`,
        request,
        { headers: this.getRequestHeaders() },
      )
      .pipe(
        map((result) => {
          if (result?.Code === Octopus.ResponseStatusCode.Successful) {
            return result.Appointment.Data.Key;
          }
          return null;
        }),
      );
  }

  private getRequestHeaders(): { [header: string]: string } {
    return {
      [insightsHeader('entity')]: 'Appointment',
    };
  }
}
